export default "__VITE_ASSET__BirXFLc8__"